<template>
  <div>
    <authentication-forms-container :image="image">
      <b-form @submit.prevent="onSubmit" class="mt-2">
        <h4 class="text-primary">ثبت نام</h4>

        <b-form-row>
          <b-col>
            <form-group :validations="$v.form.name">
              <div slot-scope="{ errors, invalid }">
                <b-form-group
                    id="input-group-1"
                    label="نام"
                    label-for="input-1"
                    class="mb-4 mt-3"
                >
                  <b-form-input
                      v-model="form.name"
                      id="input-1"
                      type="text"
                      placeholder="نام خود را وارد نمایید..."
                      class="rounded-pill"
                      :class="{ invalid }"
                  ></b-form-input>
                  <form-errors-manager :errors="errors"/>
                </b-form-group>
              </div>
            </form-group>
          </b-col>

          <b-col>
            <form-group :validations="$v.form.last_name">
              <div slot-scope="{ errors, invalid }">
                <b-form-group
                    id="input-group-2"
                    label="نام خانوادگی"
                    label-for="input-2"
                    class="mb-4 mt-3"
                >
                  <b-form-input
                      v-model="form.last_name"
                      id="input-2"
                      type="text"
                      placeholder="نام خانوادگی خود را وارد نمایید..."
                      :class="{ invalid }"
                      class="rounded-pill"
                  ></b-form-input>
                  <form-errors-manager :errors="errors"/>
                </b-form-group>
              </div>
            </form-group>
          </b-col>
        </b-form-row>

        <form-group :validations="$v.form.cellphone">
          <div slot-scope="{ errors, invalid }">
            <b-form-group
                id="input-group-3"
                label="شماره تلفن همراه"
                label-for="input-3"
                class="mb-4 mt-3"
            >
              <b-form-input
                  v-model="form.cellphone"
                  id="input-3"
                  type="text"
                  placeholder="...شماره تلفن همراه خود را وارد نمایید"
                  :class="{ invalid }"
                  class="rounded-pill text-left"
              ></b-form-input>
              <form-errors-manager :errors="errors"/>
            </b-form-group>
          </div>
        </form-group>

        <b-form-row>
          <b-col>
            <form-group :validations="$v.form.password">
              <div slot-scope="{ errors, invalid }">
                <b-form-group
                    id="input-group-4"
                    label="کلمه عبور"
                    label-for="input-4"
                    class="mb-4"
                >
                  <b-form-input
                      v-model="form.password"
                      type="password"
                      id="input-4"
                      placeholder="حداقل ۸ کاراکتر وارد نمایید..."
                      :class="{ invalid }"
                      class="rounded-pill"
                  ></b-form-input>
                  <form-errors-manager :errors="errors"/>
                </b-form-group>
              </div>
            </form-group>
          </b-col>

          <b-col>
            <form-group :validations="$v.form.password_confirmation">
              <div slot-scope="{ errors, invalid }">
                <b-form-group
                    id="input-group-5"
                    label="تکرار کلمه عبور"
                    label-for="input-5"
                    class="mb-4"
                >
                  <b-form-input
                      v-model="form.password_confirmation"
                      type="password"
                      id="input-5"
                      placeholder="حداقل ۸ کاراکتر وارد نمایید..."
                      :class="{ invalid }"
                      class="rounded-pill"
                  ></b-form-input>
                  <form-errors-manager :errors="errors"/>
                </b-form-group>
              </div>
            </form-group>
          </b-col>
        </b-form-row>

        <b-container>
          <p>
            ثبت نام شما به معنای
            <m-a :href="{name:'SinglePage',params:{slug:'terms'}}"> پذیرش شرایط</m-a>
            و
            <m-a :href="{name:'SinglePage',params:{slug:'privacy'}}">قوانین حریم‌خصوصی</m-a>
            {{ findAttributeOnSiteInfo('site_name')[0] }}
            است.
          </p>
        </b-container>

        <b-button block pill type="submit" class="my-3 w-100" variant="primary"
        >تایید
        </b-button>
        <router-link :to="{ name: 'Login' }" class="text-primary mx-2 text-decoration-none"
        >ورود
        </router-link>
      </b-form>
    </authentication-forms-container>
  </div>
</template>

<script>
import FormGroup from "@moeinmdn/mixitweb-front-classic-dashboard/src/plugin/components/validator/FormGroup";
import {sameAs, required, minLength} from "vuelidate/lib/validators";
import {phone} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/VuelidateCustomValidatoins";
import FormErrorsManager
  from "@moeinmdn/mixitweb-front-classic-dashboard/src/plugin/components/validator/FormErrorsManager.vue";
import AuthenticationFormsContainer from "../../../AuthenticationFormsContainer/AuthenticationFormsContainer.vue";

export default {
  name: "Register-1",
  components: {FormGroup, FormErrorsManager, AuthenticationFormsContainer},
  data() {
    return {
      form: {
        name: "",
        last_name: "",
        password: "",
        cellphone: "",
        password_confirmation: "",
      },
    };
  },
  props: {
    image: {
      type: String,
      default: require('../../../assets/login.png')
    }
  },
  validations: {
    form: {
      name: {required},
      last_name: {required},
      password: {required, minLength: minLength(8)},
      cellphone: {required, phone},
      password_confirmation: {required, sameAsPassword: sameAs("password")},
    },
  },
  methods: {
    invalid() {
      this.$v.$touch();
      return !this.$v.$invalid;
    },
    onSubmit() {
      if (this.invalid()) {
        this.$store.dispatch("Authentication/register", this.form);
      }
    },
  },
};
</script>
<style scoped>

</style>